export default "/images/departments-active-light.svg?5b4956eaa1ccbca1f9d00568522e0b69";